export default "__VITE_ASSET__FxGF$Vvp__"